import $ from "jquery";


export function initClickAndCollectBranch() {
    $(document).on('click', '[data-set-click-and-collect-branch]', function (event) {
        event.preventDefault();
        const button = $(this);

        const url = button.data('set-click-and-collect-branch');

        const context = button.parents('[data-set-click-and-collect-branch-context]');
        const action = context.find('[data-set-click-and-collect-branch-action]').data('set-click-and-collect-branch-action');
        const latitude = context.find('[data-set-click-and-collect-branch-latitude]').val();
        const longitude = context.find('[data-set-click-and-collect-branch-longitude]').val();
        const quantity = context.find('[data-set-click-and-collect-branch-quantity]').val();
        const variantId = context.find('[data-set-click-and-collect-branch-id]').val();
        const existing = context.find('[data-set-click-and-collect-branch-existing]').val();
        const returnUrl = context.find('[data-set-click-and-collect-branch-return-url]').data('set-click-and-collect-branch-return-url');

        const parts = {};
        switch (action) {
            case 'basket-choose-branch':
                parts['latitude'] = latitude;
                parts['longitude'] = longitude;
                parts['returnUrl'] = returnUrl;
                break;
            case 'basket-switch-item-to-click-and-collect':
                parts['variantId'] = variantId;
                parts['existing'] = existing;
                parts['returnUrl'] = returnUrl;
                break;
            case 'add-to-cart':
                parts['variantId'] = variantId;
                parts['quantity'] = quantity;
                break;
            case 'add-to-cart-and-change-branch':
                parts['variantId'] = variantId;
                parts['quantity'] = quantity;
                parts['latitude'] = latitude;
                parts['longitude'] = longitude;
                break;
        }
        const queryString = Object.keys(parts).map(key => key + '=' + parts[key]).join('&');
        if (queryString) {
            window.location = `${url}?${queryString}`;
        } else {
            window.location = url;
        }
    })
}